<template>
  <component
    :is="link ? 'a' : 'button'"
    :href="link || null"
    :type="link ? '' : (isSubmit ? 'submit' : 'button')"
    :disabled="isDisabled"
    class="btn"
    :class="{['btn--' + size]: size, ['btn--' + color]: true, 'btn--block': isBlock, 'btn--min-x': hasMinWidth}"
    @click="$emit('click')"
  >
    <slot />
  </component>
</template>

<script>
  export default {
    props: {
      isDisabled: {
        type: Boolean,
        default: false
      },
      link: {
        type: String,
        default: null
      },
      size: {
        type: String,
        default: null
      },
      hasMinWidth: {
        type: Boolean,
        default: false
      },
      isBlock: {
        type: Boolean,
        default: false
      },
      isSubmit: {
        type: Boolean,
        default: false
      },
      color: {
        type: String,
        default: "primary"
      },
      text: {
        type: String,
        default: null
      },
      type: {
        type: String,
        default: "button"
      }
    }
  };
</script>

<style lang="scss">
  @import "../../styles/shared/shared";

  .btn {
    padding: 5px 10px;
    font-weight: 700;
    outline: none;
    display: inline-block;
    border-radius: 4px;
    cursor: pointer;
    font-size: $font-size-base;
    box-shadow: none;
    border-style: solid;
    border-width: 1px;
    @include transitionOut();
    &:hover {
      @include transitionIn();
      text-decoration: none;
    }
    &:focus {
      outline: none;
    }
    &,
    &:hover {
      color: $white;
    }
    &:active:focus {

    }
    &:disabled {
      pointer-events: none;
      color: $casper;
      border-color: $casper;
      background: $zircon;
    }
    &--primary,
    &--secondary {
      &:hover:not(:disabled) {
        box-shadow: 0 2px 4px 1px rgba($shadow, 0.3);
      }
    }
    &--primary {
      color: $white;
      background-color: $btn-primary;
      border-color: $btn-primary;
      &:hover {
        background-color: $btn-primary-hover;
        border-color: $btn-primary-hover;
      }
      &:active:focus {
        background-color: $btn-primary-active;
        border-color: $btn-primary-active;
      }
    }
    &--secondary {
      background: $btn-secondary;
      color: $btn-primary;
      border-color: $btn-primary;
      &:hover {
        color: $white;
        background-color: $btn-secondary-hover;
        border-color: $btn-secondary-hover;
      }
      &:active:focus {
        color: $white;
        background-color: $btn-secondary-active;
        border-color: $btn-secondary-active;
      }
    }
    &--danger {
      color: $white;
      background-color: $guardsman;
      border-color: $guardsman;
      &:hover {
        background-color: darken($guardsman, 10%);
        border-color: darken($guardsman, 10%);
      }
      &:active:focus {
        background-color: darken($guardsman, 12%);
        border-color: darken($guardsman, 12%);
      }
    }
    &--transparent {
      color: $btn-primary;
      background-color: transparent;
      border-color: transparent;
      font-weight: 400;
      &:focus,
      &:hover {
        color: $btn-primary-hover;
      }
    }
    &--lg {
      @include minpoint(tablet) {
        font-size: $font-size-lg;
        padding: 10px 20px;
      }
    }
    &--sm {
      font-size: $font-size-sm;
    }
    &--block {
      display: block;
      width: 100%;
      margin-bottom: 1rem;
      text-align: center;
    }
    &--min-x {
      min-width: 100px;
      @include minpoint(tablet) {
        min-width: 170px;
      }
    }
    &--cancel {
      color: $tangaroa;
      &:hover::before {
        color: $btn-primary;
      }
      &::before {
        color: $tangaroa;
      }
    }
    &:not(:empty)::before {
      margin-right: 10px;
    }
  }
</style>
